import {Deposit} from '../model/shared/transaction/deposit';
import {Payment} from '../model/shared/transaction/payment';
import {BaseResponse} from './internal/baseresponse';
export class TransactionRateResult extends BaseResponse {
  data: Payment;
}



// WEBPACK FOOTER //
// ./src/app/response/transactionrateresult.ts